import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { MessageTransactionMessagePreferenceEntityEffects } from './message-transaction-message-preference.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([MessageTransactionMessagePreferenceEntityEffects])]
})
export class MessageTransactionMessagePreferenceEntityModule {}
